<button class="btn btn-upload" [ngClass]="btnClass" type="button" (click)="fileInput.click()" mat-button>
  <ng-content></ng-content>
</button>
<input #fileInput type="file" [accept]="accept" [multiple]="multiple" style="display: none" (change)="selectFile(fileInput)" />
